<template>
    <div>
        <rkm-row>

            <rkm-col cols="3">
                <rkm-form-input
                    label="Aferição de PA"
                    v-model="data.model.procedimentoConsolidado.afericaoPa"
                    :validations="validations.afericaoPa"
                    :isDisabled="isDisabled(enums.procedimento.AFERICAO_PRESSAO_ARTERIAL)"
                    number
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    label="Curativo"
                    v-model="data.model.procedimentoConsolidado.curativo"
                    :validations="validations.curativo"
                    :isDisabled="isDisabled(enums.procedimento.CURATIVO_SIMPLES)"
                    number
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    label="Glicemia Capilar"
                    v-model="data.model.procedimentoConsolidado.glicemiaCapilar"
                    :validations="validations.glicemiaCapilar"
                    :isDisabled="isDisabled(enums.procedimento.CLICEMIA_CAPILAR)"
                    number
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    label="Peso"
                    v-model="data.model.procedimentoConsolidado.peso"
                    :validations="validations.peso"
                    :isDisabled="isDisabled(enums.procedimento.MEDICAO_DE_PESO)"
                    number
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-input
                    label="Coleta de material para Exame Laboratorial"
                    v-model="data.model.procedimentoConsolidado.exameLaboratorial"
                    :validations="validations.exameLaboratorial"
                    :isDisabled="isDisabled(enums.procedimento.COLETA_DE_MATERIAL_PARA_EXAME_LABORATORIAL)"
                    number
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    label="Temperatura"
                    v-model="data.model.procedimentoConsolidado.temperatura"
                    :validations="validations.temperatura"
                    :isDisabled="isDisabled(enums.procedimento.AFERICAO_DE_TEMPERATURA)"
                    number
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    label="Altura"
                    v-model="data.model.procedimentoConsolidado.altura"
                    :validations="validations.altura"
                    :isDisabled="isDisabled(enums.procedimento.MEDICAO_DE_ALTURA)"
                    number
                />
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
//Enums
import procedimento from '@/enums/sigtap/procedimento'

export default {
    computed: {
        validations() {
            return {
                afericaoPa: { required:  this.isAvaliacaoRequired, min_value: 1, min: 1, max: 3, },
                curativo: { required:  this.isAvaliacaoRequired, min_value: 1, min: 1, max: 3, },
                glicemiaCapilar: { required:  this.isAvaliacaoRequired, min_value: 1, min: 1, max: 3, },
                peso: { required:  this.isAvaliacaoRequired, min_value: 1, min: 1, max: 3, },
                exameLaboratorial: { required:  this.isAvaliacaoRequired, min_value: 1, min: 1, max: 3, },
                temperatura: { required:  this.isAvaliacaoRequired, min_value: 1, min: 1, max: 3, },
                altura: { required: this.isAvaliacaoRequired, min_value: 1, min: 1, max: 3, },
            }
        },
        isAvaliacaoRequired() {

            return this.data.model.atendimentos.length === 0
                && !this.data.model.procedimentoConsolidado.afericaoPa
                && !this.data.model.procedimentoConsolidado.curativo
                && !this.data.model.procedimentoConsolidado.glicemiaCapilar
                && !this.data.model.procedimentoConsolidado.peso
                && !this.data.model.procedimentoConsolidado.exameLaboratorial
                && !this.data.model.procedimentoConsolidado.temperatura
                && !this.data.model.procedimentoConsolidado.altura
        },
    },
    methods: {
        isDisabled(codigo) {

            if (codigo == this.enums.procedimento.CURATIVO_SIMPLES) {

                return this.data.model.procedimentoUsuario
                    && this.data.model.procedimentoUsuario.find(procedimento => procedimento.codigo == this.enums.procedimento.CURATIVO_SIMPLES).isDisabled
                    && this.data.model.procedimentoUsuario.find(procedimento => procedimento.codigo == this.enums.procedimento.CURATIVO_ESPECIAL).isDisabled

            }

            return this.data.model.procedimentoUsuario
                && this.data.model.procedimentoUsuario.find(procedimento => procedimento.codigo == codigo).isDisabled
        }
    },
    data: () => ({
        enums: {
            procedimento
        },
    }),
    props: {
        data: { type: Object, required: false },
    },
}
</script>